<template>
  <div ref="holder" class="holder" />
</template>

<style scoped>
.holder {
  pointer-events: none;
}
.holder >>> svg > * {
  pointer-events: painted;
  transition: stroke-width 0.3s ease;
}
.holder >>> .selected {
  -webkit-animation: dash 30s linear infinite;
  stroke-dasharray: 8;
}
@-webkit-keyframes dash {
  to {
    stroke-dashoffset: -1000;
  }
}
</style>

<script>
import _ from 'lodash'

import {
  brick_port_endpoint_positions,
  SVGArrowDrawerBase,
} from './workflow_common.js'

import { WorkflowCanvasConnectorHandler } from './workflow_core.vue'

// *****************************************************************************

class SVGArrowDrawer extends SVGArrowDrawerBase {
  constructor(holding_div) {
    super(holding_div, true)
    this.clickline.mouseover(evt => this.onclmouseover(evt))
    this.clickline.mouseout(evt => this.onclmouseout(evt))
    this.line.mouseover(evt => this.oncmouseover(evt))
    this.line.mouseout(evt => this.oncmouseout(evt))
  }

  onclmouseover(evt) {
    this.line.attr({ 'stroke-width': '5px' })
    evt.stopImmediatePropagation()
  }

  onclmouseout(evt) {
    this.line.attr({ 'stroke-width': '2px' })
    evt.stopImmediatePropagation()
  }

  oncmouseover(evt) {
    this.line.attr({ 'stroke-width': '5px' })
    evt.stopImmediatePropagation()
  }

  oncmouseout(evt) {
    this.line.attr({ 'stroke-width': '2px' })
    evt.stopImmediatePropagation()
  }
}

// *****************************************************************************

export default {
  name: 'WorkflowCanvasConnector',
  components: {},
  props: ['workflow_interface', 'value', 'options', 'lhs', 'rhs'],
  data() {
    let res = {
      uid: _.uniqueId('uniqueid'),
    }
    return res
  },
  computed: {
    arrow_coords() {
      let res
      if (!_.isUndefined(this.lhs) && !_.isUndefined(this.rhs)) {
        const { x: fromxb, y: fromyb } = this.lhs.position
        const { x: fromxc, y: fromyc } = brick_port_endpoint_positions[
          this.value.from_port
        ]
        const { x: toxb, y: toyb } = this.rhs.position
        const { x: toxc, y: toyc } = brick_port_endpoint_positions[
          this.value.to_port
        ]
        const from = { x: fromxb + fromxc, y: fromyb + fromyc }
        const to = { x: toxb + toxc, y: toyb + toyc }
        res = { from, to }
      }
      return res
    },
    is_selected() {
      return this.options.selected.includes(this.value.uid)
    },
  },
  watch: {
    arrow_coords(nv) {
      this.drawer.update(nv)
    },
    is_selected(nv) {
      if (nv) {
        this.drawer.line.addClass('selected')
      } else {
        this.drawer.line.removeClass('selected')
      }
    },
  },
  mounted() {
    this.drawer = new SVGArrowDrawer(this.$refs.holder)
    this.drawer.update(this.arrow_coords)
    this.handler = new WorkflowCanvasConnectorHandler(this)
    this.workflow_interface.install(this.handler)
  },
  beforeDestroy() {
    this.handler.stop()
    this.workflow_interface.uninstall(this.handler)
    this.drawer.stop()
  },
  methods: {},
}
</script>
